// Copyright 2026, Imprivata, Inc.  All rights reserved.

import { Select } from '@imprivata-cloud/components';
import { Form } from 'antd';
import type { DefaultOptionType } from 'antd/es/select';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const TRANSLATION_ROOT = 'apps.app-modal.epic-lock-config';

// The lock option catalogs live entirely in en.json (REQ-006). Wire
// values are the bare keys the backend already knows about, so the
// raw object's keys flow straight into `appConfig.epicAppLockConfig`.
const optionMapToList = (map: Record<string, string>): DefaultOptionType[] =>
  Object.entries(map).map(([value, label]) => ({ value, label }));

const DesktopLockSection: React.FC = () => {
  const { t } = useTranslation();

  const sharedOptions = useMemo(
    () =>
      optionMapToList(
        t(`${TRANSLATION_ROOT}.shared.options`, { returnObjects: true }) as Record<string, string>,
      ),
    [t],
  );
  const privateOptions = useMemo(
    () =>
      optionMapToList(
        t(`${TRANSLATION_ROOT}.private.options`, { returnObjects: true }) as Record<string, string>,
      ),
    [t],
  );

  return (
    <div className="desktop-lock-section">
      <strong className="desktop-lock-section-title">{t(`${TRANSLATION_ROOT}.title`)}</strong>

      <Form.Item name={['epicAppLockConfig', 'sharedWorkstation']}>
        <Select
          label={t(`${TRANSLATION_ROOT}.shared.label`)}
          aria-label="shared-workstation-lock"
          options={sharedOptions}
        />
      </Form.Item>

      <Form.Item name={['epicAppLockConfig', 'privateWorkstation']}>
        <Select
          label={t(`${TRANSLATION_ROOT}.private.label`)}
          aria-label="private-workstation-lock"
          options={privateOptions}
        />
      </Form.Item>
    </div>
  );
};

export default DesktopLockSection;
